/**
 * How much room an action button takes, which is how loudly it asks to be pressed.
 *
 * A button stretched across its column reads as the thing to do next. A button no wider than its
 * own label reads as available. A destructive action wants the second: Leave Team on a work
 * agreement has hugged its label since it was written, and #5240 is the report that End Agreement
 * and Cancel Proposal were drawn louder than it.
 *
 * Both of those sit in a grid whose tracks are sized for stretched buttons, and both are styled
 * from a base that declares `width: 100%`. So hugging is an override rather than the absence of a
 * rule, which is why it is written here once instead of being spelled out at each call site.
 *
 * Where a row of actions stacks into a column, a full-width button is what reads correctly, so a
 * caller lifts this at whatever width its own row stacks. That condition is not the same in both
 * places — a work agreement asks the window, a proposal asks the pane it is drawn in — so the lift
 * is the caller's to write and is deliberately not part of this rule.
 */
export const hugsItsLabel = {
  minWidth: "unset",
  width: "auto",
} as const;
